"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToolDefinitionValue = addToolDefinitionValue;
exports.addMessage = addMessage;
const tool_definitions_1 = require("../normalize/tool-definitions");
const part_1 = require("../normalize/part");
function addToolDefinitionValue(accumulator, value, options = {}) {
    const { definitions, fullyParsed } = (0, tool_definitions_1.parseToolDefinitionValue)(value, options);
    for (const definition of definitions) {
        addToolDefinition(accumulator, definition);
    }
    return fullyParsed;
}
function getToolCallKey(part) {
    if (part.type !== "tool-call")
        return undefined;
    // Keep legacy identity (including raw argument spelling) out of the public
    // part shape while still using it for output-side compatibility deduping.
    const rawKey = (0, part_1.getToolCallKeyForPart)(part);
    if (rawKey)
        return rawKey;
    const id = part.toolCallId;
    if (typeof id === "string" && id.length > 0)
        return `id:${id}`;
    try {
        return `value:${String(part.toolName)}:${JSON.stringify(part.input)}`;
    }
    catch {
        return undefined;
    }
}
function addMessage(messages, message, context) {
    // Input is conversation history and must preserve repeated calls. Output
    // is projected into the legacy tool columns, where duplicate
    // representations are removed as they are encountered.
    const parts = context.source === "output"
        ? message.parts.filter((part) => {
            const key = getToolCallKey(part);
            if (!key)
                return true;
            if (context.toolCallKeys.has(key))
                return false;
            context.toolCallKeys.add(key);
            return true;
        })
        : message.parts;
    if (parts.length > 0) {
        if (context.source === "input" && message.role === "system") {
            context.hasSystemMessage = true;
        }
        messages.push({ ...message, parts });
    }
}
function addToolDefinition(accumulator, definition) {
    const existingIndex = accumulator.toolDefinitionIndexByName.get(definition.name);
    if (existingIndex === undefined) {
        accumulator.toolDefinitionIndexByName.set(definition.name, accumulator.toolDefinitions.length);
        accumulator.toolDefinitions.push(definition);
        return;
    }
    const existing = accumulator.toolDefinitions[existingIndex];
    if (!existing)
        return;
    accumulator.toolDefinitions[existingIndex] = {
        name: existing.name,
        description: existing.description ?? definition.description,
        inputSchema: existing.inputSchema ?? definition.inputSchema,
        type: existing.type ?? definition.type,
        providerMetadata: existing.providerMetadata && definition.providerMetadata
            ? { ...definition.providerMetadata, ...existing.providerMetadata }
            : (existing.providerMetadata ?? definition.providerMetadata),
    };
}
